export { ClockWidget } from './ClockWidget';
